/** **********cookie***********/
export const cookieHandle = {
  // 读取cookies
  getCookie: function(name) {
    var arr
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    if ((arr = document.cookie.match(reg))) {
      if (!arr[2]) {
        return null
      } else if (arr[2] !== 'null') {
       
        return arr[2]
      } else {
        return null
      }
    } else {
      return null
    }
  },
  // 删除全部cookie
  clearCookie: function() {
    var keys = document.cookie.match(/[^ =;]+(?==)/g)
    if (keys) {
      for (var i = keys.length; i--;) {
        document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString()
      }
    }
  },
  // 删除cookies
  delCookie: function(name) {
    document.cookie = name + '=0;expires=' + new Date(0).toUTCString() + ';path=/'
  },
  // 设置Cookie
  setCookie: function(name, value, time) {
    var strsec = this.getsec(time)
    var exp = new Date()
    exp.setTime(exp.getTime() + strsec * 1)
    document.cookie = name + '=' + value + ';expires=' + exp.toGMTString() + ';path=/'
    // document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=/';
  },
  // 时间转换
  getsec: function(str) {
    var str1 = str.substring(1, str.length) * 1
    var str2 = str.substring(0, 1)
    if (str2 === 's') {
      return str1 * 1000
    } else if (str2 === 'h') {
      return str1 * 60 * 60 * 1000
    } else if (str2 === 'd') {
      return str1 * 24 * 60 * 60 * 1000
    }
  }
}